import LoadSearchTemplateDialog from '@components/LoadSearchTemplateDialog';

import { SearchTemplateMetadata } from '@/apis/searchtemplates';
import SaveTemplateDialog from '@pages/SearchTemplatePage/SaveTemplateDialog';
import UpdateOrSaveAsNewSearchTemplateDialog from '@pages/SearchTemplatePage/UpdateOrSaveAsNewDialog';
import UpdateTemplateDialog from '@pages/SearchTemplatePage/UpdateTemplateDialog';
import { useTemplatePanelContent } from './useTemplatePanelContent';

type TemplatePanelDialogsProps = Pick<
  ReturnType<typeof useTemplatePanelContent>,
  | 'isSaveTemplateDialogOpen'
  | 'setIsSaveTemplateDialogOpen'
  | 'isUpdateOrSaveAsNewTemplateDialogOpen'
  | 'setIsUpdateOrSaveAsNewTemplateDialogOpen'
  | 'isUpdateTemplateDialogOpen'
  | 'setIsUpdateTemplateDialogOpen'
  | 'internalSearchTree'
  | 'placeholdersData'
  | 'organisationsToSave'
  | 'templateDescription'
  | 'searchTemplateForPreview'
  | 'setSearchTemplateForPreview'
> & {
  searchTemplateId: string | undefined;
  initialMetadata: SearchTemplateMetadata | undefined;
  onTemplateSaveSuccess?: (targetPath: string) => void;
};

export default function TemplatePanelDialogs({
  isSaveTemplateDialogOpen,
  setIsSaveTemplateDialogOpen,
  isUpdateOrSaveAsNewTemplateDialogOpen,
  setIsUpdateOrSaveAsNewTemplateDialogOpen,
  isUpdateTemplateDialogOpen,
  setIsUpdateTemplateDialogOpen,
  internalSearchTree,
  placeholdersData,
  organisationsToSave,
  templateDescription,
  searchTemplateId,
  initialMetadata,
  onTemplateSaveSuccess,
  searchTemplateForPreview,
  setSearchTemplateForPreview,
}: TemplatePanelDialogsProps) {
  return (
    <>
      {isUpdateOrSaveAsNewTemplateDialogOpen && (
        <UpdateOrSaveAsNewSearchTemplateDialog
          isOpen={isUpdateOrSaveAsNewTemplateDialogOpen}
          onClose={() => {
            setIsUpdateOrSaveAsNewTemplateDialogOpen(false);
          }}
          openSaveSearchTemplateDialog={() => setIsSaveTemplateDialogOpen(true)}
          openUpdateSearchTemplateDialog={() => {
            setIsUpdateTemplateDialogOpen(true);
          }}
        />
      )}
      {isSaveTemplateDialogOpen && (
        <SaveTemplateDialog
          isOpen={isSaveTemplateDialogOpen}
          onClose={() => {
            setIsSaveTemplateDialogOpen(false);
          }}
          onSaveSuccess={onTemplateSaveSuccess}
          searchTree={internalSearchTree}
          placeholdersData={placeholdersData}
          organisations={organisationsToSave}
          initialDescription={templateDescription}
        />
      )}
      {isUpdateTemplateDialogOpen && (
        <UpdateTemplateDialog
          isOpen={isUpdateTemplateDialogOpen}
          onClose={() => {
            setIsUpdateTemplateDialogOpen(false);
          }}
          onSaveSuccess={onTemplateSaveSuccess}
          searchTemplateId={Number(searchTemplateId)}
          searchTree={internalSearchTree}
          placeholdersData={placeholdersData}
          organisations={organisationsToSave}
          initialName={initialMetadata?.name || ''}
          initialDescription={templateDescription}
        />
      )}
      {searchTemplateForPreview && (
        <LoadSearchTemplateDialog
          searchTemplate={searchTemplateForPreview}
          onClose={() => {
            setSearchTemplateForPreview(undefined);
          }}
          fromPreview
        />
      )}
    </>
  );
}
